import { render, staticRenderFns } from "./PFSettings.vue?vue&type=template&id=4e8b3c7e&scoped=true"
import script from "./PFSettings.vue?vue&type=script&lang=js"
export * from "./PFSettings.vue?vue&type=script&lang=js"
import style0 from "./PFSettings.vue?vue&type=style&index=0&id=4e8b3c7e&prod&scoped=true&lang=css"
import style1 from "./PFSettings.vue?vue&type=style&index=1&id=4e8b3c7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8b3c7e",
  null
  
)

export default component.exports